export class MachineCategory {
  id: number | null = null;
  name: string = '';
  displayName: string = '';
  icon: string = '';

}
